import './webpack-public-path';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './services/theme/variables.css';
import './services/theme/custom-variables.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ServiceFactory} from "./services/service-factory";
import {ServiceFactoryContext} from "./react-contexts/service-factory-context";
import './extensions/array.extensions';
import {APP_ROOT_ELEMENT_ID} from "./services/application/application.service.interface";
import {AirlineAppPublicObject} from "./airline-app-public-object";

const serviceFactory = new ServiceFactory();


Object.defineProperty(window, 'AeroitaliaSearchMask', {
    value: new AirlineAppPublicObject(),
    writable: false,
    configurable: false
});

const root = ReactDOM.createRoot(
  document.getElementById(APP_ROOT_ELEMENT_ID) as HTMLElement
);


root.render(
  <React.StrictMode>
     <ServiceFactoryContext.Provider value={serviceFactory}>
         <App />
     </ServiceFactoryContext.Provider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
